import { announcementDownloadUrl, prepareAnnouncementHtml, validAnnouncementRumuz } from '../utils/announcement';

type AnnouncementHtmlProps = {
  html: string | null | undefined;
  className?: string;
  omitDownloadLink?: boolean;
  servisBulteniMi?: boolean;
  dosyaRumuz?: string | null;
};

export default function AnnouncementHtml({
  html,
  className = '',
  omitDownloadLink = false,
  servisBulteniMi = false,
  dosyaRumuz = null,
}: AnnouncementHtmlProps) {
  const prepared = prepareAnnouncementHtml(html);
  const rumuz = omitDownloadLink ? null : validAnnouncementRumuz(dosyaRumuz);
  if (!prepared && !rumuz) return null;

  const label = servisBulteniMi
    ? 'Servis bültenini indirmek için tıklayınız'
    : 'Dosyayı indirmek için tıklayınız';

  return (
    <div className={`announcement-html text-sm leading-relaxed text-gray-700 dark:text-gray-200 break-words [&_a]:!text-blue-700 dark:[&_a]:!text-blue-300 [&_a]:!underline [&_p]:mb-2 [&_p:last-child]:mb-0 ${className}`}>
      {prepared && <div dangerouslySetInnerHTML={{ __html: prepared }} />}
      {rumuz && (
        <a
          href={announcementDownloadUrl(rumuz)}
          target="_blank"
          rel="noopener noreferrer"
          className={prepared ? 'mt-3 block' : 'block'}
        >
          {label}
        </a>
      )}
    </div>
  );
}
